/**
 * App chrome: navigation rail + top bar + page outlet.
 *
 * ReportGen's MainComponent also mounts the docked report chat, the job
 * monitor, the maintenance banner, the report-issue widget, and the news modal,
 * and prefetches templates/profile for the report wizard. None of that belongs
 * to incident management, so this is a slim rewrite over the same
 * LayoutContext/TopAppBar contract.
 */
import React from "react";
import { Box, Toolbar } from "@mui/material";
import { SideBar } from "./SideBar";
import TopAppBar from "./TopAppBar";
import { ToastOffsetSync } from "../../shared/toast";

export const MainComponent: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      height: "100vh",
      overflow: "hidden",
    }}
  >
    <TopAppBar />
    {/*
      The AppBar is position="fixed" -- deliberately, because it spans the full
      width so the logo sits above the navigation rail. Fixed means it is out of
      flow and contributes NO height, so anything laid out after it starts at
      y=0 and slides underneath.
      This spacer reserves that height. A plain Toolbar is exactly as tall as
      the AppBar's own Toolbar at every breakpoint, including the dense
      variants, which a hardcoded pixel offset is not -- that is what ReportGen
      used (appBarHeightDesktop/appBarHeightMobile) and what silently drifts
      when the bar's contents change.
    */}
    <Toolbar />
    <Box sx={{ display: "flex", flexGrow: 1, minHeight: 0, overflow: "hidden" }}>
      <SideBar />
      <Box
        component="main"
        sx={{ flexGrow: 1, minWidth: 0, minHeight: 0, overflow: "auto" }}
      >
        {children}
      </Box>
    </Box>
    <ToastOffsetSync />
  </Box>
);

export default MainComponent;
